/* This example requires Tailwind CSS v2.0+ */
const faqs = [
    {
      question: 'IBAN',
      answer:
        'BE80 9731 2168 1177',
    },
    {
      question: 'BIC(Euro)',
      answer:
        'Bic ARSPBE22xxx',
    },
    {
      question: 'VISA(Dollar)',
      answer:
        ' 4302 8246 7687 2997',
    },
    // More questions...
  ]
  
  export default function Example() {
    return (
      <div className="bg-white">
        <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-20 lg:px-8">
          <div className="lg:grid lg:grid-cols-3 lg:gap-8">
            <div>
              <h2 className="text-3xl font-extrabold text-red-500">Comment nous soutenir?</h2>
              <p className="mt-4 text-lg text-gray-500">
                Si vous desirez supporter notre cause, vous pouvez nous soutenir en effectuant un don sur l'un des comptes suivants:
              </p>
            </div>
            <div className="mt-12 lg:mt-0 lg:col-span-2">
              <dl className="space-y-12">
                {faqs.map((faq) => (
                  <div key={faq.question}>
                    <dt className="text-lg leading-6 font-medium text-gray-900">{faq.question}</dt>
                    <dd className="mt-2 text-base text-gray-500">{faq.answer}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
        </div>
      </div>
    )
  }
  